<div class="flex">
  <div
    class="w-[250px] lg:relative fixed left-0 top-0 block z-20 transition-all"
    [ngClass]="isToggled ? 'translate-x-0' : ' translate-x-[-100%] lg:translate-x-0'"
  >
    <app-order-sidebar ></app-order-sidebar>
  </div>
  <div
    class="w-full min-h-[100vh] h-full overflow-y-auto overflow-x-hidden relative bg-[#F8F8F8]"
  >
    <div
      class="absolute top-0 left-0 w-full"
      [ngClass]="isToggled ? 'activeMobile-header' : ''"
    >
      <app-authenticated-header [user]="user" (toggle)="handleToggle($event)"></app-authenticated-header>
    </div>
    <div class="pt-[96px]"></div>
    <div class="container mx-auto ">
      <div class="flex justify-center card">
        <p-stepper [value]="1" class="w-10/12">
            <p-step-list>
                <p-step [value]="1">Address</p-step>
                <p-step [value]="2">Plan</p-step>
                <p-step [value]="3">Your details</p-step>
                <p-step [value]="4">Review</p-step>
            </p-step-list>
            <p-step-panels ngClass="w-full">
                <p-step-panel [value]="1" class="w-full">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col w-full h-48">
                            <div
                                class="w-full p-4 bg-white shadow-md rounded-xl"
                            >
                            <app-order-address></app-order-address>
                           </div>
                            <div class="flex justify-end pt-6">
                                <p-button label="Next" icon="pi pi-arrow-right" iconPos="right" (onClick)="activateCallback(2)" />
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>

                <p-step-panel [value]="2" class="w-full">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col w-full h-48">
                            <div
                                class="w-full p-4 bg-white shadow-md rounded-xl"
                            >
                            <app-order-internet-plan [activateCallback]="activateCallback"></app-order-internet-plan>
                            </div>
                            <div class="flex justify-end my-10 pb-14">
                              <p-button label="Next" icon="pi pi-arrow-right" iconPos="right" (onClick)="activateCallback(3)" />
                          </div>
                        </div>

                    </ng-template>
                </p-step-panel>

                <p-step-panel [value]="3">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col h-48">
                            <div
                                class="w-full p-4 bg-white shadow-md rounded-xl"
                            >
                            <app-order-setup-plan [activateCallback]="activateCallback"></app-order-setup-plan>
                            </div>
                            <div class="flex justify-end my-10 pb-14">
                              <p-button label="Next" icon="pi pi-arrow-right" iconPos="right" (onClick)="activateCallback(4)" />
                          </div>
                        </div>

                    </ng-template>
                </p-step-panel>

                <p-step-panel [value]="4">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col w-full h-48">
                            <div
                                class="w-full p-4 bg-white shadow-md rounded-xl"
                            >
                            <app-order-review></app-order-review>
                            </div>
                            <div class="flex items-center justify-between w-full pt-10">
                              <div class="flex justify-start pb-24">
                                <p-button label="Back" icon="pi pi-arrow-left" iconPos="left" (onClick)="activateCallback(4)" />
                            </div>
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-panels>
        </p-stepper>
      </div>
    </div>
  </div>

  </div>
